import Vue from 'vue';
import VueRouter from 'vue-router';
import EventBus from '@/utils/eventBus';
import store from '@/utils/store';
import { setWebpageSettingInfo } from '../utils/kkBridge';
Vue.use(VueRouter);

const routes = [
  {
    path: '/loanContract/:token/:signOrderId',
    name: 'loanContract',
    component: () => import('../pages/moneyLenderList.vue'),
    meta: {
      title: '合同列表',
      isUpload: true,
    },
  },
  {
    path: '/privacyManage',
    name: 'privacyManage',
    component: () => import('../../../pages/privacyManage.vue'),
    meta: {
      title: '维信卡卡贷',
      voiceAuth: '允许访问麦克风',
      photoAuth: '允许访问相册',
      locationAuth: '允许访问位置信息',
      contactAuth: '允许访问通讯录',
      cameraAuth: '允许访问相机',
      calendarAuth: '允许访问日历',
      phoneAuth: '允许访问电话',
      callAuth: '允许访问通话记录',
    },
  },
  {
    path: '/creditContracts',
    name: 'creditContracts',
    component: () => import('../pages/creditContracts.vue'),
    meta: {
      title: '征信授权书',
      isUpload: true,
    },
  },
  {
    path: '/cfcaAuth',
    name: 'cfcaAuth',
    component: () => import('../pages/cfcaAuth.vue'),
    meta: {
      title: '数字证书申请及使用授权告知函',
    },
  },
  // 注册协议
  {
    path: '/register/:type',
    name: 'register',
    component: () => import('../pages/register.vue'),
    meta: {
      title: '服务许可协议',
      isUpload: true,
    },
  },
  // 隐私政策
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../pages/privacy.vue'),
    meta: {
      title: '隐私政策',
      isUpload: true,
    },
  },
  // 服务许可协议和隐私政策（客服人脸认证一键登录使用）
  {
    path: '/registerAndPrivacy',
    name: 'registerAndPrivacy',
    component: () => import('../pages/registerAndPrivacy.vue'),
    meta: {
      title: '服务许可协议、隐私政策',
      isUpload: true,
    },
  },
  // 隐私政策简要版
  {
    path: '/privacyBrief',
    name: 'privacyBrief',
    component: () => import('../pages/privacyBrief.vue'),
    meta: {
      title: '隐私政策',
      isUpload: true,
    },
  },
  {
    path: '/privacySence',
    name: 'privacySence',
    component: () => import('../pages/privacySence.vue'),
    meta: {
      title: 'APP设备权限目录',
    },
  },
  {
    path: '/permissionList',
    name: 'permissionList',
    component: () => import('../pages/permissionList.vue'),
    meta: {
      title: '应用权限说明',
    },
  },
  {
    path: '/sdkList',
    name: 'sdkList',
    component: () => import('../pages/sdkList.vue'),
    meta: {
      title: '第三方SDK目录',
    },
  },
  {
    path: '/personAuth',
    name: 'personAuth',
    component: () => import('../pages/personAuth.vue'),
    meta: {
      title: '个人信息授权书',
    },
  },
  {
    path: '/personInfoCollect',
    name: 'personInfoCollect',
    component: () => import('../pages/personal-info-collect.vue'),
    meta: {
      title: '个人信息收集说明',
    },
  },
  {
    path: '/personInfoShare',
    name: 'personInfoShare',
    component: () => import('../pages/personal-info-share.vue'),
    meta: {
      title: '个人信息共享说明',
    },
  },
  {
    path: '/authContract/faceAuthContract',
    name: 'faceAuthContract',
    component: () => import('../pages/faceAuthContract.vue'),
    meta: {
      title: '维信卡卡贷人脸识别授权书',
      isUpload: true,
    },
  },
  {
    path: '/contractView/:type',
    name: 'contractView',
    component: () => import('../pages/contractView.vue'),
    meta: {
      title: '合同',
      isUpload: true,
    },
  },
  {
    path: '/changeCardContractDetail',
    name: 'changeCardContractDetail',
    component: () => import('../pages/changeCardContractDetail.vue'),
    meta: {
      title: '合同详情',
    },
  },
  {
    path: '/oneKeyBindCardService',
    name: 'oneKeyBindCardService',
    component: () => import('../pages/oneKeyBindCardService.vue'),
    meta: {
      title: '一键绑卡用户服务协议',
      isUpload: true,
    },
  },
  {
    path: '/oneKeyBindCardDuXiaoManUser',
    name: 'oneKeyBindCardDuXiaoManUser',
    component: () => import('../pages/oneKeyBindCardDuXiaoManUser.vue'),
    meta: {
      title: '用户个人信息共享授权书',
      isUpload: true,
    },
  },
  {
    path: '/oneKeyBindCardDuXiaoManPay',
    name: 'oneKeyBindCardDuXiaoManPay',
    component: () => import('../pages/oneKeyBindCardDuXiaoManPay.vue'),
    meta: {
      title: '快捷支付服务协议',
      isUpload: true,
    },
  },
  // 卡卡平台合同
  {
    path: '/platformPersonInfo/:token',
    name: 'platform-personinfo',
    component: () => import('../pages/platformPersonInfo'),
    meta: {
      title: '个人信息共享授权书',
    },
  },
  {
    path: '/kakaPlatform/baixin/debit-auth',
    name: 'debit-auth',
    component: () => import('../kakaPlatform/baixin/debit-auth'),
    meta: {
      title: '委托扣款协议',
    },
  },
  {
    path: '/kakaPlatform/baixin/service',
    name: 'service',
    component: () => import('../kakaPlatform/baixin/service'),
    meta: {
      title: '百信银行服务协议',
    },
  },
  {
    path: '/kakaPlatform/baixin/privacy',
    name: 'baixinPrivacy',
    component: () => import('../kakaPlatform/baixin/privacy'),
    meta: {
      title: '百信银行隐私政策',
    },
  },
  {
    path: '/kakaPlatform/baixin/credit-auth',
    name: 'credit-auth',
    component: () => import('../kakaPlatform/baixin/credit-auth'),
    meta: {
      title: '百信银行征信授权书',
    },
  },
  {
    path: '/kakaPlatform/baixin/person-credit-auth',
    name: 'person-credit-auth',
    component: () => import('../kakaPlatform/baixin/person-credit-auth'),
    meta: {
      title: '个人信息查询及使用授权书',
    },
  },
  {
    path: '/kakaPlatform/baixin/loan',
    name: 'loan',
    component: () => import('../kakaPlatform/baixin/loan'),
    meta: {
      title: '授信借款合同',
    },
  },
  {
    path: '/kakaPlatform/baixin/loan-borrower',
    name: 'loan-borrower',
    component: () => import('../kakaPlatform/baixin/loan-borrower'),
    meta: {
      title: '个人借款借据凭证',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: '/unionContract/',
  routes,
});
router.beforeEach((to, from, next) => {
  // 部分手机没有scroll方法
  document.getElementById('contractBody') && document.getElementById('contractBody').scroll && document.getElementById('contractBody').scroll(0, 0);
  const meta = to.meta || {};
  document.title = meta.title || '';
  EventBus.$emit('clearRequesting'); // 触发清除请求
  store.commit('setToken', to.params.token || '');
  store.commit('setAccessToken', to.query.accessToken || '');
  setWebpageSettingInfo(to.meta.title, true, to.meta.isUpload);
  next();
});
export default router;
